export default __webpack_public_path__ + "static/media/scooter-prodcutos-3-mb@2x.9e4c4ebf.jpg";